import { cn } from '@/utils/cn';

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn('animate-pulse rounded-md bg-ink-200/80 dark:bg-ink-700/70', className)}
    />
  );
}
